import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "カテゴリ編集")
], -1)
const _hoisted_3 = { class: "mt-5 justify-content-center" }
const _hoisted_4 = { class: "d-flex justify-content-center my-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("戻る")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-success mx-2"
}, "更新", -1)

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useMessenger } from '@/plugins/message'
import { useNicotto, ConciergeCategory } from '@/plugins/nicotto'
import CategoryForm from '@/components/forms/ConciergeCategory.vue'
import ButtonDelete from '@/components/ui/ButtonDelete.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditView',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as {
  categoryId: string
}



const router = useRouter()
const messenger = useMessenger()
const nicotto = useNicotto()
const category = ref<ConciergeCategory>(new ConciergeCategory())
let iconUrl: string|null // アイコン画像の初期値保持用
let iconImage: File|null = null // アップロードした画像ファイル
nicotto.concierge.getCategory(props.categoryId)
  .then(data => {
    category.value = data
    iconUrl = data.iconUrl
  })

const onChangeIcon = (file: File|null) => {
  iconImage = file
  if (file == null) {
    // リセット時は初期値に戻す
    category.value.iconUrl = iconUrl
  }
}

const onDeleteConfirmed = async() => {
  try {
    await nicotto.concierge.deleteCategory(category.value)
    messenger.set('concierge.categories.deleteSucceeded')
    router.push('/concierge/categories')
  } catch (err) {
    console.log(err)
    messenger.set('concierge.categories.deleteFailed')
  }
}

const save = async() => {
  try {
    await nicotto.concierge.updateCategory(category.value, iconImage)
    messenger.set('concierge.categories.updateSucceeded')
    router.push('/concierge/categories')
  } catch (err:any) {
    console.log(err)
    for (let i = 0; i < err.errors.length; i++) {
      if (err.errors[i].message.indexOf('data is already exists.') !== -1 ) {
        messenger.set('concierge.categories.saveFailedAlreadyExists')
        return
      }
    }
    messenger.set('concierge.categories.updateFailed')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CategoryForm, {
        modelValue: category.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event)),
        onSubmit: save,
        onChangeIcon: onChangeIcon
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/concierge/categories",
              class: "btn btn-secondary mx-2",
              role: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(ButtonDelete, {
              class: "mx-2",
              onDeleteConfirmed: onDeleteConfirmed
            }),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})